import { Fragment, useEffect, useRef } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "./App.css";
import Login from "./pages/login";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ProtectedRoute from "./routes/protectedRoute";
import PrivateRoute from "./routes/privateRoute";
import Dashboard from "./pages/dashboard";
import SignUp from "./pages/signUp";
import { IsTokenExpired } from "./common/jwtToken";
// import { SocketContext } from "./context/socket";
import { useContext } from "react";
import { useDispatch } from "react-redux";

import GlobalLoader from "./components/GlobalLoader";
import UserManagementPage from "./pages/UserManagementPage/index.js";
import ErrorBoundary from "./common/ErrorBoundary.js";
import FAQTablePage from "./pages/FAQTablePage/index.js";
import CourseTablePage from "./pages/CourseTablePage/index.js";
import CampaignTablePage from "./pages/CampaignTablePage/index.js";
import PledgeTablePage from "./pages/PledgeTablePage/index.js";
import NotificationTablePage from "./pages/NotificationTablePage/index.js";
import ContentManagementPage from "./pages/ContentManagementPage/index.js";
import ProductTablePage from "./pages/ProductTablePage/index.js";
import CategoryTablePage from "./pages/CategoryTablePage/index.js";
import AddProductPage from "./pages/ProductTablePage/AddProductPage.js";
// import VariantTablePage from "./pages/VariantTablePage/index.js";
import ContactTablePage from "./pages/ContactTablePage/index.js";
// import NamesPage from "./pages/NamesPage/index.js";
import VariantsPage from "./pages/VariantsPage/index.js";
import OrdersPage from "./pages/OrdersPage/index.js";
import OrderDetailsPage from "./pages/OrdersPage/OrderDetailsPage.js";
import OpenApp from "./pages/open/index.js";
import ImageUploadPage from "./pages/ImageUploadPage/index.js";

function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const socket = useContext(SocketContext);
  const audioRef = useRef(null);
  const token = localStorage.getItem("token");
  useEffect(() => {
    if (token !== null) {
      const isExpired = IsTokenExpired(token);
      if (isExpired === true) {
        localStorage.removeItem("token");
        navigate("/");
      }
    }

    // socket.on("orderplace", async (data) => {
    //   console.log(data);
    //   if (audioRef.current) {
    //     audioRef.current.play().catch((error) => {
    //       // Handle errors in case play fails
    //       console.error("Error playing audio:", error);
    //     });
    //   }
    //   // dispatch(handleAddOrder(data));
    //   // toast.success("You have new order");
    // });
  }, [token]);

  return (
    <>
      <ErrorBoundary>
        <GlobalLoader />
        <Routes>

          <Route element={<ProtectedRoute />}>
            {/* <Route path="/dashboard" element={<Dashboard />} /> */}

            <Route path="/faq" element={<FAQTablePage />} />
            <Route path="/course" element={<CourseTablePage />} />
            <Route path="/campaignmanagement" element={<CampaignTablePage />} />
            <Route path="/pledge" element={<PledgeTablePage />} />
            <Route path="/notification" element={<NotificationTablePage />} />
            <Route path="/contentmanagement" element={<ContentManagementPage />} />
            <Route path="/users" element={<UserManagementPage />} />
            {/* E-Commerce Group */}
            <Route path="/ecommerce/products" element={<ProductTablePage />} />
            <Route path="/ecommerce/products/new" element={<AddProductPage />} />
            <Route path="/ecommerce/products/edit/:id" element={<AddProductPage />} />
            <Route path="/ecommerce/categories" element={<CategoryTablePage />} />
            <Route path="/ecommerce/variants" element={<VariantsPage />} />
            <Route path="/ecommerce/orders" element={<OrdersPage />} />
            <Route path="/ecommerce/orders/:id" element={<OrderDetailsPage />} />
            <Route path="/contact" element={<ContactTablePage />} />
            <Route path="/upload" element={<ImageUploadPage />} />
          </Route>

          <Route element={<PrivateRoute />}>
            <Route path="/" element={<Login />} />
          </Route>
          <Route path="/signup" element={<SignUp />} />
          <Route exact path="/open" name="OpenApp Page" element={<OpenApp />} />

        </Routes>
        <ToastContainer />
        <audio ref={audioRef} id="order-sound" src="/assets/sound/sound.mp3" />
      </ErrorBoundary>
    </>
  );
}

export default App;
